<div class="schedule-pickup-page white-content-page">
    <upsc-page-header [pageTitle]="'siteMenu.track.scheduledPickups'|translate"></upsc-page-header>

    <div class="ups-content-block schedule-pickup-content-actions">
        <div class="schedule-pickup-left-actions">
            <upsc-date-range-selector
                [customDateRangeFormGroup]="customDateRangeFormGroup"
                [formattedStartDate]="formattedStartDate"
                [formattedEndDate]="formattedEndDate"
                class="schedule-pickup-action-date-range-selector">
            </upsc-date-range-selector>

            <form [formGroup]="searchFormGroup" (ngSubmit)="onSearchSubmit($event, searchFormGroup.value)" class="schedule-pickup-action-form">
                <mat-form-field>
                    <mat-label>{{'searchShipment'|translate}}</mat-label>
                    <input matInput type="text" formControlName="keyword">
                    <mat-icon matSuffix (click)="onSearchSubmit($event, searchFormGroup.value)" class="search">search</mat-icon>
                </mat-form-field>
            </form>

            <!-- <button type="button"
                    mat-raised-button
                    class="alternative-button schedule-pickup-action-export-btn"
                    (click)="download()">
                {{'Export'|translate}}
            </button> -->
        </div>

        <div class="schedule-pickup-right-actions">
            <!-- <button type="button"
                    mat-raised-button
                    class="alternative-button schedule-pickup-action-schedule-new-pickup-btn"
                    (click)="schedulePickup()"
            >Schedule New Pickup
            </button> -->

            <a class="alternative-button schedule-pickup-action-how-to-schedule-new-pickup-link" 
               (click)="openHowToSchedulePickupDialog()"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_14261_172" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_14261_172)">
                        <path d="M12.7125 17.3198C12.9093 17.1226 13.0078 16.8812 13.0078 16.5955C13.0078 16.31 12.9092 16.0688 12.712 15.872C12.5148 15.6753 12.2735 15.577 11.988 15.577C11.7025 15.577 11.4613 15.6756 11.2645 15.8728C11.0677 16.0699 10.9692 16.3113 10.9692 16.5968C10.9692 16.8822 11.0678 17.1234 11.265 17.3203C11.4622 17.5169 11.7035 17.6152 11.989 17.6152C12.2745 17.6152 12.5157 17.5168 12.7125 17.3198ZM11.2808 14.0345H12.6885C12.7013 13.5423 12.7734 13.1491 12.9047 12.8548C13.0363 12.5606 13.3552 12.1706 13.8615 11.6848C14.3013 11.2449 14.6382 10.8388 14.872 10.4663C15.106 10.0939 15.223 9.65417 15.223 9.147C15.223 8.28617 14.9137 7.61375 14.2952 7.12975C13.6766 6.64592 12.9448 6.404 12.1 6.404C11.2653 6.404 10.5747 6.62675 10.028 7.07225C9.48117 7.51775 9.09108 8.04242 8.85775 8.64625L10.1423 9.1615C10.2641 8.8295 10.4724 8.50608 10.7673 8.19125C11.0621 7.87658 11.4999 7.71925 12.0808 7.71925C12.6718 7.71925 13.1086 7.88108 13.3913 8.20475C13.6741 8.52858 13.8155 8.88467 13.8155 9.273C13.8155 9.61283 13.7187 9.92375 13.525 10.2057C13.3315 10.4877 13.0848 10.7602 12.7848 11.023C12.1283 11.6153 11.7135 12.0878 11.5405 12.4405C11.3673 12.793 11.2808 13.3243 11.2808 14.0345ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#004791"/>
                    </g>
                </svg>
                How to Schedule a Pickup
            </a>
        </div>
    </div>

    <div class="table-wrapper" [class.responsive-table]="dtOptions.responsive">
        <table datatable
               [dtOptions]="dtOptions"
               [dtTrigger]="dtTrigger"
               class="stripe"
               [hidden]="!filteredSchedulePickupList">
            <thead>
                <tr>
                    <th class="all trigger-column"></th>
                    <th>
                        {{ 'Carrier'|translate }}
                    </th>
                    <th>
                        Pick Up Date
                    </th>
                    <th>
                        Pick Up Time
                    </th>
                    <th>
                        Pick Up Address
                    </th>
                    <th *ngIf="isEUUser">
                        {{ 'ShipToCountry'|translate }}
                    </th>
                    <th>
                        {{ 'ShipTo'|translate }}
                    </th>
                    <th>
                        Tracking Number
                    </th>
                    <th>
                        Carrier Status
                    </th>
                    <th>
                        Dispatch Information (PRN)
                    </th>
                    <th *ngIf="isEUUser">
                        {{ 'InsuredValue'|translate }}
                    </th>
                    <th>
                        {{ 'Status'|translate }}
                    </th>
                    <th class="all"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of filteredSchedulePickupList">
                    <td class="trigger-cell"></td>
                    <td class="text-uppercase"> {{ item.CarrierCode }}
                    </td>
                    <td>
                        {{ item.PickUpDate | date : 'MM-dd-yyyy' }}
                    </td>
                    <td>
                        {{ item.PickUpTime }}
                    </td>
                    <td>
                        {{ item.PickUpAddress }}
                    </td>
                    <td *ngIf="isEUUser">
                        <span *ngIf="item.ShipToCountry!==''">{{ item.ShipToCountry }}</span>
                    </td>
                    <td>
                        <span matTooltip="{{ item?.ShipToAddress }}" [matTooltipPosition]="'right'" class="ship-to-address-link">{{ item.ShipToCompanyName }}</span>
                    </td>
                    <td>
                        <a href="{{ item?.TrackingNumberLink }}" target="_blank">{{ item?.TrackingNumber }}</a>
                    </td>
                    <td>
                        <span>{{ item?.CarrierStatus }}</span>
                    </td>
                    <td>{{ item.DispatchConfirmationNumber }}
                    </td>
                    <td *ngIf="isEUUser">
                        {{ item.InsuredValue }}
                    </td>
                    <td>
                        <span *ngIf="item.DispatchStatus === '0'">
                            <button role="button"
                                    class="btn btn-transparentbullet"
                                    style="background-color:#3fa700;"></button>
                            {{ 'Active'|translate }}
                        </span>
                        <span *ngIf="item.DispatchStatus === '1'">
                            <button role="button" class="btn btn-redbullet"></button>
                            {{ 'Cancelled'|translate }}
                        </span>
                    </td>
                    <td>
                        <div class="actions">
                            <button mat-raised-button
                                    *ngIf="item.DispatchStatus === '0'"
                                    class="alternative-button"
                                    (click)="confirmVoidPickup(item?.ShipmentId)">{{ 'Void'|translate }}
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <upsc-element-blocker *ngIf="isLoading"></upsc-element-blocker>
    </div>
</div>